import type { UserRole } from "./types";

export type AppView = "dashboard" | "clients" | "case_detail" | "documents" | "settings" | "account";

export const ROUTES: Record<AppView, string> = {
  dashboard: "dashboard",
  clients: "clients",
  case_detail: "case_detail",
  documents: "documents",
  settings: "settings",
  account: "account",
};

export const viewLabel: Record<AppView, string> = {
  dashboard: "Dashboard",
  clients: "Clients",
  case_detail: "Case Detail",
  documents: "Documents",
  settings: "Settings",
  account: "My Account",
};

// ✅ FIX: canonicalize role strings so "Tax Pro", "taxpro", "tax_pro" all become "taxpro"
const normalizeRole = (role: any): string =>
  (role || "")
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, "");

export const logNav = (role: UserRole | string, from: string, to: string, source?: string) => {
  try {
    console.log("[NAV]", {
      role: normalizeRole(role),
      source: source || "unknown",
      from,
      to,
      at: new Date().toISOString(),
    });
  } catch {
    // ignore
  }
};

export const getDefaultRouteForRole = (role: UserRole | string): AppView => {
  const r = normalizeRole(role);

  // Staff default
  if (r === "firmowner" || r === "owner" || r === "admin" || r === "manager" || r === "taxpro" || r === "staff") {
    return "dashboard";
  }

  // Client default
  return "dashboard";
};

export const viewAllowedForRole = (view: AppView, role: UserRole | string): boolean => {
  const r = normalizeRole(role);

  const isStaff =
    r === "firmowner" || r === "owner" || r === "admin" || r === "manager" || r === "taxpro" || r === "staff";

  if (!isStaff) {
    return view === "dashboard" || view === "case_detail" || view === "documents" || view === "account";
  }

  if (view === "settings") return r === "firmowner" || r === "owner" || r === "admin" || r === "manager";
  return true;
};

export const performNavigate = (
  setView: (v: AppView) => void,
  view: AppView,
  role: UserRole | string,
  source: string,
  after?: () => void,
  firmId?: string | null
) => {
  if (!viewAllowedForRole(view, role)) return;

  const seg = window.location.pathname.split("/").filter(Boolean);

  const resolvedFirm =
    firmId ||
    (seg[0] === "location" ? seg[1] : null) ||
    new URLSearchParams(window.location.search).get("locationId") ||
    new URLSearchParams(window.location.search).get("staff_context") ||
    sessionStorage.getItem("FILERSHUB_SSO_LOC");

  const next = resolvedFirm
    ? `/location/${resolvedFirm}/${ROUTES[view]}${window.location.search}`
    : `/${ROUTES[view]}${window.location.search}`;

  logNav(role, window.location.pathname + window.location.search, next, source);

  window.history.pushState({}, "", next);
  window.dispatchEvent(new Event("filershub:navigate"));

  setView(view);
  after?.();
};
